import { render, staticRenderFns } from "./TinyLog.vue?vue&type=template&id=63d0211a"
import script from "./TinyLog.vue?vue&type=script&lang=ts"
export * from "./TinyLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports